// @flow
import {
  defaultStateDataCurrent,
  getStateItems,
  type State,
} from 'app/common/ui-components/filter';

import filterDataFilter from '../filterData';
import { getSourcesData } from '../filterData/filterDataItems';


const sourceItems = async (state: State) => {
  const items = getStateItems(filterDataFilter, state);
  const actors = getSourcesData(items);

  return ([actors, defaultStateDataCurrent]);
};

export default sourceItems;
